/**
 * Единый аккаунт проверяющего (реестр ПО, экспертиза, демо-доступ).
 * SSOT legal: PROJECT_DOCS/legal/reestr-po-markbase/28-akkaunt-proverayushchego-edinyj-uam.md
 *
 * Пароль НЕ хранится в коде — только в PDF инструкции для Минцифры (05).
 */

export const PLATFORM_REVIEWER_EMAIL = String(
  process.env.REACT_APP_PLATFORM_REVIEWER_EMAIL || 'ekspertiza-po@markbase.ru',
)
  .trim()
  .toLowerCase();

export const PLATFORM_REVIEWER_COMPANY_UUID = String(
  process.env.REACT_APP_PLATFORM_REVIEWER_COMPANY_UUID
    || process.env.PLATFORM_REVIEWER_COMPANY_UUID
    || '10000000-0000-4000-8000-000000000004',
).trim();

export const PLATFORM_REVIEWER_USER_UUID = String(
  process.env.REACT_APP_PLATFORM_REVIEWER_USER_UUID
    || process.env.PLATFORM_REVIEWER_USER_ID
    || '10000000-0000-4000-8000-000000000005',
).trim();

export const PLATFORM_REVIEWER_INITIAL_BALANCE_RUB = Number(
  process.env.REACT_APP_PLATFORM_REVIEWER_INITIAL_BALANCE_RUB || 100000,
);

export const PLATFORM_REVIEWER_COMPANY_NAME = String(
  process.env.REACT_APP_PLATFORM_REVIEWER_COMPANY_NAME
    || 'Демонстрация Markbase — экспертиза Минцифры',
).trim();

/** Платный тариф по умолчанию (не DEMO, не unlimited). */
export const PLATFORM_REVIEWER_DEFAULT_TARIFF_SLUG =
  process.env.REACT_APP_PLATFORM_REVIEWER_TARIFF_SLUG || 'business';

export const PLATFORM_REVIEWER_AUTH_URL = 'https://auth.markbase.ru';
export const PLATFORM_REVIEWER_APP_URL = 'https://app.markbase.ru';

/** Query на app.markbase.ru/login для кнопки «Демо-доступ» */
export const PLATFORM_REVIEWER_DEMO_LOGIN_QUERY = 'demo=reviewer';
